import * as i0 from '@angular/core';
import { Component, Input, ViewChild, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import * as i1 from '@angular/material/tabs';
import { MatTab, MatTabsModule } from '@angular/material/tabs';

class RebNgxMatTabItemComponent {
    constructor() {
        /**
         * Item label
         *
         * @required
         */
        this.label = '';
        /**
         * Disable item
         */
        this.disabled = false;
        this.matTab = null;
    }
}
RebNgxMatTabItemComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.10", ngImport: i0, type: RebNgxMatTabItemComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
RebNgxMatTabItemComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.10", type: RebNgxMatTabItemComponent, selector: "reb-ngx-mat-tab-item", inputs: { label: "label", disabled: "disabled" }, viewQueries: [{ propertyName: "matTab", first: true, predicate: MatTab, descendants: true }], ngImport: i0, template: "<mat-tab [label]=\"label\" [disabled]=\"disabled\">\n  <ng-template matTabContent>\n    <ng-content></ng-content>\n  </ng-template>\n</mat-tab>\n", components: [{ type: i1.MatTab, selector: "mat-tab", inputs: ["disabled", "label", "aria-label", "aria-labelledby", "labelClass", "bodyClass"], exportAs: ["matTab"] }], directives: [{ type: i1.MatTabContent, selector: "[matTabContent]" }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.10", ngImport: i0, type: RebNgxMatTabItemComponent, decorators: [{
            type: Component,
            args: [{ selector: 'reb-ngx-mat-tab-item', template: "<mat-tab [label]=\"label\" [disabled]=\"disabled\">\n  <ng-template matTabContent>\n    <ng-content></ng-content>\n  </ng-template>\n</mat-tab>\n" }]
        }], propDecorators: { label: [{
                type: Input
            }], disabled: [{
                type: Input
            }], matTab: [{
                type: ViewChild,
                args: [MatTab]
            }] } });

class RebNgxMatTabItemModule {
}
RebNgxMatTabItemModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.10", ngImport: i0, type: RebNgxMatTabItemModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
RebNgxMatTabItemModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.10", ngImport: i0, type: RebNgxMatTabItemModule, declarations: [RebNgxMatTabItemComponent], imports: [CommonModule, MatTabsModule], exports: [RebNgxMatTabItemComponent] });
RebNgxMatTabItemModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.10", ngImport: i0, type: RebNgxMatTabItemModule, imports: [[CommonModule, MatTabsModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.10", ngImport: i0, type: RebNgxMatTabItemModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [RebNgxMatTabItemComponent],
                    imports: [CommonModule, MatTabsModule],
                    exports: [RebNgxMatTabItemComponent]
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { RebNgxMatTabItemComponent, RebNgxMatTabItemModule };
